'use client';
import styled from 'styled-components';

import { useDevice } from '@contexts/device';
const Container = styled.div<{ hasTopMargin?: boolean }>`
  margin-top: ${({ hasTopMargin }) => (hasTopMargin ? '50px' : '0')};
  @media ${({ theme }) => `max-width: ${theme.breakPoint.LARGE_1X}`} {
    margin-top: ${({ hasTopMargin }) => (hasTopMargin ? '30px' : '0')};
  }
`;
const Title = styled.h2<{ small?: boolean }>`
  font-size: ${({ small }) => (small ? '18px' : '24px')};
  font-weight: bold;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin: 0;
  margin-bottom: 20px;
  @media ${({ theme }) => `max-width: ${theme.breakPoint.LARGE_1X}`} {
    font-size: 18px;
  }
`;
const Description = styled.p`
  font-size: 16px;
  font-weight: normal;
  line-height: 1.31;
  color: ${({ theme }) => theme.palette.brownishGrey};
  margin: 0;
  margin-bottom: 20px;
`;
const ItemInfo = ({
  title,
  description,
  hasTopMargin = true,
}: {
  title: string;
  description: string;
  hasTopMargin?: boolean;
}) => {
  const { isDesktop } = useDevice();
  return (
    <Container hasTopMargin={hasTopMargin}>
      <Title small={isDesktop ? false : true}>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};
export default ItemInfo;
